
const filterPerformancesByCinemaId = (performancesOrder, performancesItems, cinemaId) => {
    const filteredPerformances = []


    performancesOrder && performancesOrder.length > 0 && performancesOrder.map(id => {
        if(cinemaId == performancesItems[id].cinemaId) {
            filteredPerformances.push(performancesItems[id])
        }
    })

    return filteredPerformances
}

export default filterPerformancesByCinemaId